import CreateReportTab from './CreateReportTab'

export default CreateReportTab
